
import React from 'react';

export default function Humility() {
  return <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9736 4.6708C13.9743 4.18869 13.8847 3.71117 13.7098 3.2657C13.535 2.82022 13.2784 2.41557 12.9547 2.07499V2.07499C12.3017 1.38667 11.4161 1 10.4927 1C9.56933 1 8.68375 1.38667 8.03072 2.07499L7.48752 2.64771L6.94433 2.07499C6.2913 1.38667 5.40571 1 4.48233 1C3.55894 1 2.67336 1.38667 2.02033 2.07499V2.07499C1.69649 2.41549 1.43964 2.8201 1.26454 3.26557C1.08944 3.71104 0.99954 4.18859 1 4.6708C1 10.2571 7.45963 13 7.45963 13L7.48899 12.969L7.51835 13L7.54037 12.9768V13C7.54037 13 14 10.2571 14 4.6708H13.9736Z" stroke="#ff6326 " stroke-linejoin="bevel" />
  </svg>;
}
